import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

const DialogSucesso = ({ visible, message, onHide, onConfirm }) => {
  const handleClose = () => {
    // Primeiro fecha o diálogo
    if (onHide) onHide();
    // Depois executa o callback se existir
    if (onConfirm) onConfirm();
  };

  return (
    <Dialog
      visible={visible}
      style={{ width: "350px", fontFamily: "'Rajdhani', sans-serif" }}
      onHide={() => {}} // Não permite fechar clicando fora
      draggable={false}
      closable={false}
      header={null}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
          padding: "10px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "60px",
            height: "60px",
            borderRadius: "50%",
            backgroundColor: "#22C55E20",
            color: "#22C55E",
          }}
        >
          <i className="pi pi-check-circle" style={{ fontSize: "2.5rem" }}></i>
        </div>
        <p
          style={{
            textAlign: "center",
            fontSize: "1rem",
            margin: 0,
            color: "#374151",
          }}
        >
          {message}
        </p>
        <Button
          label="OK"
          icon="pi pi-check"
          onClick={handleClose}
          className="p-button-success p-button-sm"
          style={{
            outline: "none",
            boxShadow: "none",
            padding: "6px 20px",
            minWidth: "100px",
            fontWeight: "500",
            fontSize: "0.875rem",
            backgroundColor: "#22C55E",
            borderColor: "#22C55E",
          }}
        />
      </div>
    </Dialog>
  );
};

export default DialogSucesso;